/**
 * 숫자에 천 단위 구분자 추가 (ko-KR 고정)
 *
 * @example formatNumber(1234567) // "1,234,567"
 */
export const formatNumber = (value: number): string =>
  value.toLocaleString('ko-KR')
